import React, { useEffect, useState } from "react";
import {
  AdminAllCustomers,
  AdminViewSingleOrderByUserId,
} from "../utils/Api/ApiCalls";
import exportFromJSON from "export-from-json";

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [currentCustomers, setCurrentCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [customersPerPage, setCustomersPerPage] = useState(40);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    const getCustomers = async () => {
      const customerData = await AdminAllCustomers();
      setCustomers(customerData);
      updateCurrentCustomers(1, customerData);
      console.log(customerData);
    };
    getCustomers();
  }, []);

  const updateCurrentCustomers = (pageNumber, customersList) => {
    const indexOfLastItem = pageNumber * customersPerPage;
    const indexOfFirstItem = indexOfLastItem - customersPerPage;
    const currentCustomers = customersList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    setCurrentCustomers(currentCustomers);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    updateCurrentCustomers(pageNumber, customers);
  };

  const handleExportUsers = () => {
    setIsExporting(true);
    const currentDate = new Date();
    const time = currentDate.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "numeric",
      minute: "numeric",
    });
    const dateTime =
      time + ":" + currentDate.toLocaleDateString().replace("/", "-");

    const data = customers;
    const fileName = "Argone_Users_" + dateTime;
    const exportType = exportFromJSON.types.xls;

    exportFromJSON({ data, fileName, exportType });

    setIsExporting(false);
  };

  const CustomersList = ({ customer }) => {
    const [total, setTotal] = useState({});

    useEffect(() => {
      const getTotals = async () => {
        const orders = await AdminViewSingleOrderByUserId(customer.id);
        var totalPurchase = 0;
        var count = 0;
        if (orders?.data) {
          for (let index = 0; index < orders.data.length; index++) {
            totalPurchase += orders?.data[index].totalPrice;
            count += 1;
          }
        }
        setTotal({ purchase: totalPurchase.toLocaleString(), count: count });
      };
      getTotals();
    }, [customer.id]);

    return (
      <tr key={customer.id}>
        <td width="40%">
          <a href="#" class="itemside">
            <div class="left">
              <img
                // src="assets/imgs/people/avatar-2.png"
                src={
                  customer.image
                    ? `https://backend.argone.ng/uploads/${customer.image}`
                    : "assets/imgs/people/avatar-2.png"
                }
                class="img-sm img-avatar"
                alt="Userpic"
              />
            </div>
            <div class="info pl-3">
              <h6 class="mb-0 title">{customer?.fullname}</h6>
              <small class="text-muted">Customer ID: #{customer?.id}</small>
            </div>
          </a>
        </td>
        <td>{customer?.email}</td>
        <td>{customer?.phoneNum}</td>
        <td>
          <span class="badge rounded-pill alert-success">
            {customer?.isActive === 1 ? "Active" : "Not active"}
          </span>
        </td>
        {/* <td>08.07.2020</td> */}
        <td>
          <div class="info pl-3">
            {/* <h6 class="mb-0 title">₦675,785.54</h6> */}
            <h6 class="mb-0 title">₦ {total?.purchase}</h6>
            <small class="text-muted">No. of purchase: {total?.count}</small>
          </div>
        </td>
        <td class="text-end">
          <a
            href={`/customer-detail/${customer.id}`}
            class="btn btn-sm btn-brand rounded font-sm mt-15"
          >
            View details
          </a>
        </td>
      </tr>
    );
  };
  return (
    <div>
      <section class="content-main">
        <div class="content-header">
          <h2 class="content-title">Customers list</h2>
          <div
            class="btn btn-md btn-brand rounded font-sm mt-15"
            onClick={handleExportUsers}
          >
            {isExporting ? <div className="spinner"></div> : "Export Customers"}
          </div>
        </div>

        <div class="card mb-4">
          <header class="card-header">
            <div class="row gx-3">
              <div class="col-lg-4 col-md-6 me-auto">
                <input
                  type="text"
                  placeholder="Search..."
                  class="form-control"
                />
              </div>
              <div class="col-lg-2 col-md-3 col-6">
                <select class="form-select">
                  <option>Status</option>
                  <option>Active</option>
                  <option>Disabled</option>
                  <option>Show all</option>
                </select>
              </div>
              <div class="col-lg-2 col-md-3 col-6">
                <select class="form-select">
                  <option>Show 20</option>
                  <option>Show 30</option>
                  <option>Show 40</option>
                </select>
              </div>
            </div>
          </header>
          {/* <!-- card-header end// --> */}
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Status</th>
                    {/* <th>Registered</th> */}
                    <th>Total Purchase</th>
                    <th class="text-end">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCustomers.map((customer) => (
                    <CustomersList key={customer.id} customer={customer} />
                  ))}{" "}
                </tbody>
              </table>
              {/* <!-- table-responsive.// --> */}
            </div>
          </div>
          {/* <!-- card-body end// --> */}
        </div>
        {/* <!-- card end// --> */}
        <div className="pagination-area mt-15 mb-50">
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-start">
              {Array.from(
                { length: Math.ceil(customers.length / customersPerPage) },
                (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <a
                      className="page-link"
                      href="#"
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </a>
                  </li>
                )
              )}
            </ul>
          </nav>
        </div>
      </section>
    </div>
  );
};

export default CustomerList;
